"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DELETE_USER_ACCOUNT = void 0;
const client_1 = require("@apollo/client");
exports.DELETE_USER_ACCOUNT = client_1.gql `
  mutation deleteUserAccount($id: ID!) {
    deleteUserAccount(id: $id)
  }
`;
